import api from '../../plugins/api';

const getItems = (params) => {
  return api.get('/api/shop/getItems', params);
};

export default getItems;
